module.exports = __webpack_public_path__ + "img/in-progress.a4e3f727.svg";